export enum NativeUCAppType {
    Sport888 = 'Sport888',
}
